

















































































































import { openSelectList } from '@/main/router/routerPath';
import { editFactory } from '@/main/pages';

import { NAME, apiFunctionNames } from './constants';
import { NahradniHodinovaSazba } from './nahradniHodinovaSazba';
import { NahradniSazbaLakovaci } from './nahradniSazbaLakovaci';
import { SmluvniCenaND } from './smluvniCenaND';
import { PrevzitHodnoty } from './prevzitHodnoty';
import { store } from './store/edit';
import { DEPENDENT_TABLES } from './store/types';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: {
				NahradniHodinovaSazba: NahradniHodinovaSazba.name,
				SmluvniCenaNd: SmluvniCenaND.name,
				NahradniSazbaLakovaci: NahradniSazbaLakovaci.name,
			},
			apiFunctionNames,
		};
	},
	created() {
		if (!this.mainCollapse.length) {
			// HlavniUdaje tab is opened by default
			this.mainCollapse = ['HlavniUdaje'];
		}
	},
	methods: {
		toggleVyrazenDateValue() {
			this.VyrazenDat = this.VyrazenDat ? null : new Date();
		},
		changeStariOdDo() {
			this.StariVozuOd = null;
			this.StariVozuDo = null;
		},
		async openPrevzetiHodnotSelectList({ tableToRefresh, api }: PreberHodnoty) {
			this.tablesToRefresh = tableToRefresh ? [tableToRefresh] : [...DEPENDENT_TABLES];
			this.prevzetiApi = api;
			await openSelectList(PrevzitHodnoty.name, {
				afterRowSelection: this.prevzetiHodnot as ({ row }: { row: Record<string, any> }) => void,
				filter: { ZakaznikSk: this.ZakaznikSk },
			});
		},
		async openPrevzitHodnotySelect(preberHodnoty: PreberHodnoty) {
			const valid = await this.validate();

			if (!valid) return;

			this.isCreateMode && await this.changeToEdit();

			this.openPrevzetiHodnotSelectList(preberHodnoty);
		},
		async prevezmiNahradniHodinovaSazba() {
			this.openPrevzitHodnotySelect({
				tableToRefresh: this.dependencies.NahradniHodinovaSazba,
				api: apiFunctionNames.copyFakturaceProfilHodSzbNahr,
			});
		},
		async prevezmiSmluvniCenaNd() {
			this.openPrevzitHodnotySelect({
				tableToRefresh: this.dependencies.SmluvniCenaNd,
				api: apiFunctionNames.copyFakturaceProfilNdPcNahr,
			});
		},
		async prevezmiNahradniSazbaLakovaci() {
			this.openPrevzitHodnotySelect({
				tableToRefresh: this.dependencies.NahradniSazbaLakovaci,
				api: apiFunctionNames.copyFakturaceProfilLakSzbNahr,
			});
		},
	},
});

type PreberHodnoty = {
	tableToRefresh: string | undefined;
	api: string;
};
